import { t, Trans } from '@lingui/macro';
// import { Button } from 'antd';
import React, { useEffect, useMemo } from 'react';
// import ContactFilesLightGallery from '../../../components/LightGallery/ContactFilesLightGallery';
// import { EyeOutlined } from '@ant-design/icons';
import { AuditActionLiteral } from 'bukku/containers/AppPage/Reports/AuditTrails/enums';
import AuditModuleActions from 'bukku/redux/AuditModule/actions';
import dayjs from 'dayjs';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useReadStateSuccess } from '../../../helpers/useReadStateSuccess';
import { useDispatch } from '../../Providers/helpers/useDispatch';
import { StyledTable } from './AuditsTable.style';
import { getWebUrlPrefix } from '../../../redux/AuditModule/helper/getWebUrlPrefix';

export default function AuditsTable({auditName, id, audits}) {
    const {
        toggleAuditsDrawer,
        setAuditId,
        readAudits,
    } = useMemo(() => AuditModuleActions.withAuditName(auditName), [auditName]);

    const dispatch = useDispatch();
    const isLoadingAudits = useSelector(state => state.AuditModule[auditName].auditReadAllState === 'request');
    const auditsPagination = useSelector(state => state.AuditModule[auditName].auditsPagination);
    const audit = useSelector(state => state.AuditModule[auditName].audit, shallowEqual);
    const auditReadState = useSelector(state => state.AuditModule[auditName].auditReadState);
    const view = useSelector(state => state.App.view);

    const isAuditReadSuccess = useReadStateSuccess(auditReadState);
    useEffect(() => {
        if (isAuditReadSuccess && view === 'MobileView')
            dispatch(toggleAuditsDrawer(false));
    }, [isAuditReadSuccess, view, toggleAuditsDrawer, dispatch]);

    const history = useHistory();
    const location = useLocation();

    const onClickLog = record => {
        // dispatch(readContactAudit(id, record.user_id));
        const isAuditLogPage = location.pathname.includes('logs');

        const webUrl = getWebUrlPrefix(auditName);

        // So that onBack will not go back to another audit log
        if (isAuditLogPage)
            history.replace(`${webUrl}/${id}/logs/${record.id}`);
        else
            history.push(`${webUrl}/${id}/logs/${record.id}`);

        dispatch(setAuditId(id));
    };

    const onRow = record => ({
        onClick: () => onClickLog(record),
    });

    // highlight the row which the user is currently viewing
    const rowClassName = record => {
        const isAuditLogPage = location.pathname.includes('logs');
        // console.log('aaa rowClassName', {isAuditLogPage, record, audit});
        if (isAuditLogPage && record.id === audit?.id)
            return 'is-featured';

        return 'hand-cursor';
    };

    const renderName = (text, record) => {
        if (record.myinvois_ready_request_name) // will have value if its filled from contact request myInvois data form
            return <i>{record.myinvois_ready_request_name}</i>;
        if (record.myinvois_submission_request_name)
            return <i>{record.myinvois_submission_request_name}</i>;
        if (text)
            return text;

        return <i><Trans>System</Trans></i>;
    };

    const columns = [
        {
            title: t`Date`,
            dataIndex: 'created_at',
            key: 'created_at',
            width: '44%',
            render: text => (
                <>
                    <span>{dayjs(text).format('DD/MM/YYYY')}</span>
                    &nbsp;
                    <span className="time--greyed">{dayjs(text).format('h:mm a')}</span>
                </>
            ),
        },
        {
            title: t`User`,
            dataIndex: 'user_first_name',
            key: 'user_first_name',
            width: '30%',
            render: renderName,
        },
        {
            title: t`Action`,
            dataIndex: 'action',
            key: 'action',
            width: '26%',
            render: text => (<span>{AuditActionLiteral()[text]}</span>),
        },
    ];

    const onAuditLogsTableChange = pagination => {
        const pageProps = {
            page: pagination.current,
            page_size: pagination.pageSize,
        };

        dispatch(readAudits(id, pageProps));
    };

    return (
        <StyledTable
            size="small"
            onRow={onRow}
            rowClassName={rowClassName}
            columns={columns}
            rowKey="id"
            dataSource={audits}
            pagination={{ ...auditsPagination, hideOnSinglePage: true}}
            onChange={onAuditLogsTableChange}
            loading={isLoadingAudits}
        />
    );
}
